import { replace } from 'react-router-redux';
import { joinPath } from '@eb/path-utils';
import { BASE_URL, PURCHASE_CONFIRMATION_PATH } from '../constants';
import {
    isAddAttendeesOrder,
    isOrganizerInitiatedTransferOrder,
    isTransferredOrder,
} from '../selectors/order';
import { notifyParentProtectCheckout as notifyParentProtectCheckoutAction } from './notifyParent';
import { completeOrderActions } from './order/common';

export const showPurchaseConfirmation = () => async (dispatch, getState) => {
    const state = getState();
    const {
        app: { isEventbriteTLD },
        order: { ticketBuyerSettings: { redirectUrl } = {} },
        event: { id: eventId },
    } = state;

    await dispatch(completeOrderActions());

    if (isEventbriteTLD && redirectUrl) {
        dispatch(notifyParentProtectCheckoutAction({ disable: true }));
    }

    if (isAddAttendeesOrder(state)) {
        return null;
    }

    if (isTransferredOrder(state)) {
        let url = window.location.origin;

        if (isOrganizerInitiatedTransferOrder(state)) {
            url += `/reports?eid=${eventId}&rid=h&filterby=attending,all`;
        } else {
            url += '/gettickets';
        }

        window.open(url, '_self');
        return null;
    }

    return dispatch(replace(joinPath(BASE_URL, PURCHASE_CONFIRMATION_PATH)));
};
